var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLanding03Medium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 260,
    viewBox: "0 0 347 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1565)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1_1565)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 327,
    height: 240,
    rx: 24,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.332 36.082V53.7383H49.1445V36.082H51.332ZM36.7031 48.875C41.332 46.6777 43.4609 43.6895 43.8516 39.6758H37.6016V37.957H46.0586C46.0586 43.2109 44.0176 47.6738 37.8359 50.6133L36.7031 48.875ZM58.7734 36.8633C61.0586 36.8535 62.8555 38.1719 63.2949 40.1055H66.4883V36.082H68.6562V45.5547H66.4883V41.8633H63.3145C62.8945 43.8457 61.0781 45.1836 58.7734 45.1836C56.0684 45.1836 54.1055 43.4453 54.1055 41.0039C54.1055 38.5918 56.0684 36.8535 58.7734 36.8633ZM56.1758 41.0039C56.1758 42.4199 57.25 43.3574 58.7734 43.3477C60.2578 43.3574 61.3223 42.4199 61.332 41.0039C61.3223 39.5879 60.2578 38.6699 58.7734 38.6797C57.25 38.6699 56.1758 39.5879 56.1758 41.0039ZM57.0156 53.5234V46.375H59.1641V48.25H66.4883V46.375H68.6562V53.5234H57.0156ZM59.1641 51.7656H66.4883V49.9297H59.1641V51.7656ZM74.5938 50.6133L72.9531 56.082H71.0977L72.1133 50.6133H74.5938ZM87.3086 40.3203C87.2891 43.4746 88.8711 46.6582 91.6055 47.9766L90.2773 49.7148C88.3633 48.748 86.9863 46.8828 86.2344 44.6367C85.4629 47.0391 84.0176 49.0312 81.9961 50.0469L80.668 48.3086C83.5098 46.9609 85.1309 43.582 85.1406 40.3203V37.5078H87.3086V40.3203ZM92.6602 53.7383V36.082H94.8281V42.9961H97.543V44.8516H94.8281V53.7383H92.6602ZM114.398 46.082V47.8398H107.367V53.7188H105.219V47.8398H98.2656V46.082H114.398ZM100.238 44.0117V36.9805H112.426V44.0117H100.238ZM102.367 42.3125H110.258V38.7188H102.367V42.3125ZM130.238 36.082V45.0859H128.09V36.082H130.238ZM115.551 43.3672C118.412 42.459 119.916 40.1934 119.906 37.8789V36.5117H122.152V37.8789C122.143 40.125 123.637 42.2246 126.43 43.0742L125.375 44.7539C123.324 44.1191 121.859 42.8105 121.059 41.1309C120.258 42.957 118.754 44.3926 116.645 45.0664L115.551 43.3672ZM118.559 47.5859V45.9062H130.277V50.4961H120.727V51.8633H130.805V53.582H118.598V48.875H128.109V47.5859H118.559ZM152.289 36.082V53.7578H150.102V36.082H152.289ZM138.168 43.6016C138.158 39.793 140.102 37.3711 142.777 37.3711C145.424 37.3711 147.377 39.793 147.387 43.6016C147.377 47.4395 145.424 49.8516 142.777 49.8516C140.102 49.8516 138.158 47.4395 138.168 43.6016ZM140.258 43.6016C140.258 46.3164 141.283 47.8887 142.777 47.8984C144.262 47.8887 145.277 46.3164 145.277 43.6016C145.277 40.9062 144.262 39.3242 142.777 39.3242C141.283 39.3242 140.258 40.9062 140.258 43.6016ZM161.195 40.3203C161.176 43.4746 162.758 46.6582 165.492 47.9766L164.164 49.7148C162.25 48.748 160.873 46.8828 160.121 44.6367C159.35 47.0391 157.904 49.0312 155.883 50.0469L154.555 48.3086C157.396 46.9609 159.018 43.582 159.027 40.3203V37.5078H161.195V40.3203ZM166.547 53.7383V36.082H168.715V42.9961H171.43V44.8516H168.715V53.7383H166.547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5664 73.2207C40.5664 75.3672 41.9883 77.5684 43.7109 78.416L43.0547 79.2773C41.7148 78.5732 40.5938 77.1377 40.0605 75.4492C39.5137 77.2471 38.3652 78.7783 36.998 79.5098L36.3145 78.6484C38.0918 77.7734 39.5 75.4355 39.5137 73.2207V71.0059H40.5664V73.2207ZM45.8984 69.9531V74.8887H47.9355V75.8184H45.8984V82.1074H44.832V69.9531H45.8984ZM59.707 77.0215V77.9102H54.6348V82.1074H53.582V77.9102H48.5781V77.0215H59.707ZM58.2578 70.6367V75.3672H50.0137V70.6367H58.2578ZM51.0664 71.5117V74.5195H57.1914V71.5117H51.0664ZM70.7129 69.9531V76.2559H69.6602V69.9531H70.7129ZM70.7266 76.8711V79.7832H63.9043V81.0957H71.1641V81.9707H62.8516V78.9492H69.6602V77.7324H62.8242V76.8711H70.7266ZM64.998 71.2383C64.9844 72.9609 66.2969 74.4785 68.1016 75.0664L67.5684 75.9004C66.1465 75.415 65.0117 74.3965 64.4648 73.084C63.918 74.499 62.7764 75.6133 61.334 76.1328L60.7734 75.2852C62.6055 74.6426 63.9043 73.0293 63.9043 71.2383V70.3086H64.998V71.2383ZM74.7871 80.084L73.7207 83.8027H72.709L73.4609 80.084H74.7871ZM83.9473 71.9219C83.9473 73.5762 85.2051 75.0938 86.9688 75.6953L86.3809 76.543C85.0342 76.0508 83.9746 75.0459 83.4414 73.7812C82.9219 75.21 81.8418 76.3379 80.4199 76.8848L79.8457 76.0234C81.6641 75.3398 82.8809 73.7129 82.8945 71.8398V70.582H83.9473V71.9219ZM89.3887 69.9531V73.125H91.2207V74.0273H89.3887V77.3496H88.3223V69.9531H89.3887ZM85.4922 77.6641C87.9941 77.6641 89.498 78.4707 89.498 79.8652C89.498 81.2871 87.9941 82.0801 85.4922 82.0801C82.9902 82.0801 81.459 81.2871 81.459 79.8652C81.459 78.4707 82.9902 77.6641 85.4922 77.6641ZM85.4922 78.5254C83.6602 78.5254 82.5254 79.0312 82.5391 79.8652C82.5254 80.7266 83.6602 81.2188 85.4922 81.2324C87.3379 81.2188 88.459 80.7266 88.459 79.8652C88.459 79.0312 87.3379 78.5254 85.4922 78.5254ZM95.3359 70.5273C96.9697 70.5137 98.207 71.4639 98.4395 72.8652H100.982V69.9531H102.062V76.4746H100.982V73.7539H98.4531C98.2344 75.1895 96.9834 76.1465 95.3359 76.1465C93.4902 76.1465 92.1777 74.998 92.1777 73.3301C92.1777 71.6758 93.4902 70.5137 95.3359 70.5273ZM95.3359 71.4434C94.0918 71.4297 93.2031 72.209 93.2031 73.3301C93.2031 74.4375 94.0918 75.2441 95.3359 75.2441C96.5664 75.2441 97.4414 74.4375 97.4414 73.3301C97.4414 72.209 96.5664 71.4297 95.3359 71.4434ZM95.3086 77.0898V78.6348H100.982V77.0898H102.062V81.9434H94.2285V77.0898H95.3086ZM95.3086 81.0684H100.982V79.4961H95.3086V81.0684ZM109.582 77.6367C112.193 77.6367 113.848 78.457 113.848 79.8652C113.848 81.2598 112.193 82.0801 109.582 82.0801C106.984 82.0801 105.33 81.2598 105.33 79.8652C105.33 78.457 106.984 77.6367 109.582 77.6367ZM109.582 78.457C107.641 78.4707 106.383 79.0039 106.396 79.8652C106.383 80.7129 107.641 81.2324 109.582 81.2324C111.523 81.2324 112.768 80.7129 112.781 79.8652C112.768 79.0039 111.523 78.4707 109.582 78.457ZM113.752 70.582V71.6074C113.752 72.5918 113.752 73.5762 113.41 74.834L112.357 74.7109C112.686 73.4531 112.686 72.5645 112.686 71.6074V71.457H105.412V70.582H113.752ZM115.16 75.627V76.502H104.1V75.627H108.68V73.2754H109.732V75.627H115.16ZM125.688 69.9531V73.6582H127.52V74.5605H125.688V78.8535H124.607V69.9531H125.688ZM122.406 70.8965C122.406 74.0273 120.164 76.3516 116.664 77.4453L116.199 76.584C119.111 75.6748 121.012 73.9385 121.244 71.7988H116.705V70.8965H122.406ZM126.248 80.9453V81.8477H118.072V77.9512H119.139V80.9453H126.248Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 327,
    height: 240
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 327,
    height: 240,
    rx: 24,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 183.542C38 180.149 40.7508 177.398 44.144 177.398H107.12C110.513 177.398 113.264 180.149 113.264 183.542V246.134H38V183.542Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.328 121.144C100.328 117.751 103.079 115 106.472 115H169.448C172.841 115 175.592 117.751 175.592 121.144V201.4H100.328V121.144Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.656 193.72C279.656 190.327 282.407 187.576 285.8 187.576H348.776C352.169 187.576 354.92 190.327 354.92 193.72V245.944H279.656V193.72Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.96 153.534C233.96 152.291 234.71 151.17 235.859 150.695L270.419 136.413C271.171 136.102 272.014 136.102 272.766 136.413L307.326 150.695C308.475 151.17 309.224 152.291 309.224 153.534V245.944H233.96V153.534Z",
    fill: "#F96C44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4321 157.624C83.4321 154.231 86.1829 151.48 89.5761 151.48H152.552C155.945 151.48 158.696 154.231 158.696 157.624V245.944H83.4321V157.624Z",
    fill: "#C4D5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.696 176.439C158.696 174.743 160.072 173.367 161.768 173.367H230.888C232.585 173.367 233.96 174.743 233.96 176.439V245.943H158.696V176.439Z",
    fill: "#1C7EC7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.696,
    y: 126.52,
    width: 75.264,
    height: 70.272,
    rx: 6.144,
    fill: "#1C7EC7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.8799,
    y: 160.695,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.8799,
    y: 178.744,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.8799,
    y: 196.793,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.8799,
    y: 214.84,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.368,
    y: 160.695,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.328,
    y: 160.695,
    width: 54.528,
    height: 12.672,
    rx: 3.072,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.328,
    y: 178.744,
    width: 54.528,
    height: 12.672,
    rx: 3.072,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.328,
    y: 196.793,
    width: 54.528,
    height: 12.672,
    rx: 3.072,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.328,
    y: 214.84,
    width: 54.528,
    height: 12.672,
    rx: 3.072,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.368,
    y: 178.744,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.368,
    y: 196.793,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.368,
    y: 214.84,
    width: 26.88,
    height: 12.672,
    rx: 3.072,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.913 149.176C167.913 144.935 171.351 141.496 175.593 141.496C179.834 141.496 183.273 144.935 183.273 149.176V158.392C183.273 160.089 181.897 161.464 180.201 161.464H170.985C169.288 161.464 167.913 160.089 167.913 158.392V149.176Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.913 175.287C167.913 171.046 171.351 167.607 175.593 167.607C179.834 167.607 183.273 171.046 183.273 175.287V184.503C183.273 186.2 181.897 187.575 180.201 187.575H170.985C169.288 187.575 167.913 186.2 167.913 184.503V175.287Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.913 201.399C167.913 197.157 171.351 193.719 175.593 193.719C179.834 193.719 183.273 197.157 183.273 201.399V210.615C183.273 212.311 181.897 213.687 180.201 213.687H170.985C169.288 213.687 167.913 212.311 167.913 210.615V201.399Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.648 149.176C188.648 144.935 192.086 141.496 196.328 141.496C200.569 141.496 204.008 144.935 204.008 149.176V158.392C204.008 160.089 202.633 161.464 200.936 161.464H191.72C190.023 161.464 188.648 160.089 188.648 158.392V149.176Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.648 175.287C188.648 171.046 192.086 167.607 196.328 167.607C200.569 167.607 204.008 171.046 204.008 175.287V184.503C204.008 186.2 202.633 187.575 200.936 187.575H191.72C190.023 187.575 188.648 186.2 188.648 184.503V175.287Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.648 201.399C188.648 197.157 192.086 193.719 196.328 193.719C200.569 193.719 204.008 197.157 204.008 201.399V210.615C204.008 212.311 202.633 213.687 200.936 213.687H191.72C190.023 213.687 188.648 212.311 188.648 210.615V201.399Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.384 149.176C209.384 144.935 212.823 141.496 217.064 141.496C221.306 141.496 224.744 144.935 224.744 149.176V158.392C224.744 160.089 223.369 161.464 221.672 161.464H212.456C210.76 161.464 209.384 160.089 209.384 158.392V149.176Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.384 175.287C209.384 171.046 212.822 167.607 217.064 167.607C221.305 167.607 224.744 171.046 224.744 175.287V184.503C224.744 186.2 223.368 187.575 221.672 187.575H212.456C210.759 187.575 209.384 186.2 209.384 184.503V175.287Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.384 201.399C209.384 197.157 212.823 193.719 217.064 193.719C221.306 193.719 224.744 197.157 224.744 201.399V210.615C224.744 212.311 223.369 213.687 221.672 213.687H212.456C210.76 213.687 209.384 212.311 209.384 210.615V201.399Z",
    fill: "#2C93E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1565",
    x: 0,
    y: 0,
    width: 347,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1_1565",
    x: 0,
    y: 0,
    width: 347,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1565",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_1565"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLanding03Medium);
export default __webpack_public_path__ + "static/media/img_landing_03_medium.19f89cef14e4927a923242cf20c5ccc5.svg";
export { ForwardRef as ReactComponent };